/* Core & libraries */
import React, { useState, useRef, useEffect } from "react";
import { useTheme } from "react-jss";
import {defineMessages, FormattedMessage, useIntl} from "react-intl";
import {ErrorMessage, Field, Formik, getIn} from "formik";
import ContainerFluid from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import UCButton from "../../../buttons";

/* Helpers, constants, custom methods, internal libraries */
import {
  createValidationPolicyYupSchema,
  useValidationService
} from "../../../../resources/validations/validations";
import {usePeopleService} from "../../../../services/peopleService";
import {useNotificationContext} from "../../../../contexts/notificationContext";

/* Components */

/* Styles */
import styles from "./styles.js"
import {colors} from "../../../../constants/colors";



const messages = defineMessages({
  updateEmailPlaceholderMessage: {
    id: 'admin.updateCitiEmailPlaceholder'
  },
})

const Content = props => {
  const { setShowModal, companyDetails } = props;

  const theme = useTheme();
  const classes = styles({ theme });

  const formRef = useRef(null);
  const intl = useIntl();

  const { updateCitiEmailMockedApiValidationObj } = useValidationService()
  const [updateCitiEmailSchema, setupdateEmailSchema] = useState({});
  const [sameEmail, setSameEmail] = useState(false)
  const [domainEmail, setDomainEmail] = useState(false)
  const [existingEmail, setExistingEmail] = useState(false)

  const { setNotification } = useNotificationContext();
  const { updateUserEmail, updateUserEmailVerification, sendEmailVerificationCode } = usePeopleService()


  useEffect(() => {
    // //TODO: api call to get validations //simpleMockedApiValidationObj
    const result = createValidationPolicyYupSchema(updateCitiEmailMockedApiValidationObj);
    setupdateEmailSchema(result)
  }, [])

  const submitForm = async (values, setSubmitting) => {
    const response  = await updateUserEmailVerification(values)
    if (response.status === "ERROR") {
      const errorCode = response?.errors[0]?.errorCode;
      if ( errorCode === '4335' ) {
        setSameEmail(true)
      } else if ( errorCode === '4334' ) {
        setDomainEmail(true)
      } else if ( errorCode === '4333' ) {
        setExistingEmail(true)
      }
    } else if (response.status === "SUCCESS" ) {
      const updateEmailResponse = await updateUserEmail({
        ...values,
        roleId: "",
        groupEntityId: "",
        marketingNewsAndOffers: "",
        marketingBusinessSummary:"" ,
        marketingPromotions: "",
        isTripLinkAccount: "",
        verificationCode: ""
      })
      if (updateEmailResponse.status === "SUCCESS") {
        setNotification(
          "success",
          <FormattedMessage id="updateEmailModal.notificationSuccesTitle"/>,
          <FormattedMessage id="updateEmailModal.notificationSuccesText"/>
        )
        setSubmitting(false)
        setShowModal(false)
        window.location.reload()
      }
    }
  }

  const handleFormSubmit = () => {
    if (formRef.current) {
      formRef.current.handleSubmit()
    }
  }

  const emailChange = (e, handleChange, setFieldValue) => {
    setSameEmail(false)
    setDomainEmail(false)
    setExistingEmail(false)
    const value = e.target.value;
    handleChange(e);
    setFieldValue("emailAddress", value);
  };

  return (
    <div className={classes.newEmail}>
      <Formik
        innerRef={formRef}
        initialValues={{
          userId: companyDetails?.primaryAdminId,
          emailAddress: "",
        }}
        validationSchema={ updateCitiEmailSchema }
        onSubmit={(values, { setSubmitting }) => {
          submitForm(values, setSubmitting);
        }}
      >
        {({
            values,
            errors,
            touched,
            setFieldTouched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setFieldValue
          }) => (

          <>
            <form onSubmit={handleSubmit} >
              <div className={classes.inputContainer}>
                <label htmlFor="updatedEmailAddress" className={classes.label}>
                  <FormattedMessage id="admin.updateCitiEmailLabel"/>
                </label>
                <Field
                  placeholder={intl.formatMessage(messages.updateEmailPlaceholderMessage)}
                  type="text"
                  name="emailAddress"
                  id="emailAddress"
                  onChange={(e) =>
                    emailChange(e, handleChange, setFieldValue)
                  }
                  className={
                    errors.emailAddress && touched.emailAddress
                      ? "input-error"
                      : sameEmail || domainEmail || existingEmail
                        ? "input-error"
                        : null
                  }
                />
                <ErrorMessage
                  name="emailAddress"
                  component="span"
                  className={classes.error}
                />
                {sameEmail && (
                  <div className={classes.nameError}>
                    <FormattedMessage id="updateEmailModal.sameEmailError" />
                  </div>
                )}
                {domainEmail && (
                  <div className={classes.nameError}>
                    <FormattedMessage id="updateEmailModal.domainEmailError" />
                  </div>
                )}
                {existingEmail && (
                  <div className={classes.nameError}>
                    <FormattedMessage id="updateEmailModal.existingEmailError" />
                  </div>
                )}

              </div>
              <div className={classes.btnContainer}>
                <ContainerFluid>
                  <Row>
                    <Col className={classes.colCancel}>
                      <UCButton
                        onClick={() => setShowModal(false)}
                        type="default"
                        className={classes.cancelBtn}
                        text={<FormattedMessage id="admin.updateCitiEmailCancel"/>}
                      />
                    </Col>
                    <Col className={classes.colRemove} >
                      <UCButton
                        className={classes.createBtn}
                        onClick={handleFormSubmit}
                        type="primary"
                        text={<FormattedMessage id="admin.updateCitiEmailUpdate"/>}
                        spinner={{
                          name: "updateEmailSpinner",
                          size: 20,
                          color: colors.white
                        }}
                      />
                    </Col>
                  </Row>
                </ContainerFluid>
              </div>
            </form>
          </>
        )}
      </Formik>
    </div>
  )
}

export default Content;